import PropTypes from 'prop-types';

const propTypes = {
  sheetId: PropTypes.string,
  title: PropTypes.string.isRequired,
};

class Sheet {
  static propTypes = propTypes;
}

export default Sheet;
